/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { dataError, dataLoaded, dataLoading, dataNotAsked, isDataNotAsked } from '../../utils/dataState';
import { AuthActions, AuthLogoutAction } from '../auth/types';
import { ProjectsActions, ProjectsActionTypes, ProjectsState } from './types';

const { GET_USER_PROJECTS_FAILURE, GET_USER_PROJECTS_REQUEST, GET_USER_PROJECTS_SUCCESS } = ProjectsActions;

export const initialProjectsState: ProjectsState = {
  isFetching: false,
  errorMessage: undefined,
  items: [],
  dataState: dataNotAsked(),
};

export function projects(state = initialProjectsState, action: ProjectsActionTypes | AuthLogoutAction): ProjectsState {
  switch (action.type) {
    case GET_USER_PROJECTS_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: undefined,
        dataState: isDataNotAsked(state.dataState) ? state.dataState : dataLoading(),
      };
    case GET_USER_PROJECTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        items: action.payload.items,
        dataState: dataLoaded(),
      };
    case GET_USER_PROJECTS_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload.errorMessage,
        dataState: dataError(),
      };
    case AuthActions.AUTH_LOGOUT:
      return { ...initialProjectsState };
    default:
      return state;
  }
}
